import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SignInTabs from "./components/ui/SignInTabs";
import Router from "./components/Router";
import { authenticate } from "./redux/actions/auth";
import { selectAuthorizedAuthState } from "./redux/selectors/auth";

class App extends Component {
  componentDidMount() {
    if (!this.props.auth) {
      this.props.authenticate();
    }
  }

  render() {
    const { auth } = this.props;
    if (auth) {
      return <Router />;
    }
    return <SignInTabs />;
  }
}

const mapStateToProps = state => {
  const auth = selectAuthorizedAuthState(state);

  return {
    auth
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ authenticate }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
